<div class="BackgroundContainer">
  <abc-authentication-webapi-editor requiredSystemName="BaSYS" errorClass="greenError">
  </abc-authentication-webapi-editor>
</div>
